(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltHistoryController', OltHistoryController);

    OltHistoryController.$inject = ['$scope', '$rootScope', '$locale', '$filter', 'OltService', 'OltData'];

    function OltHistoryController($scope, $rootScope, $locale, $filter, OltService, OltData) {

        var vm = this;
        var historyData;
        /* global d3 */

        var charts = {
            memory: {name: 'memory', color: '#fec45a'},
            cpu: {name: 'cpu', color: '#00a9d5'}
        };

        vm.chart = {};
        vm.selectedChart = 'memory';

        function getHistory() {
            OltService.getHistory(OltData.detail.id).then(historySuccess);
        }
        getHistory();

        $scope.$on('oltDetailLoad', getHistory);

        function historySuccess(data) {
            historyData = data;
            vm.selectedChart = 'memory';
            createChart();
        }

        function createChart() {
            vm.chart.data = generateData();
            vm.chart.options = generateOptions();
            vm.chart.api.refresh();
        }

        vm.changeChart = function () {
            vm.selectedChart = vm.selectedChart == 'memory' ? 'cpu' : 'memory';
            createChart();
        };

        var cleanListener = $rootScope.$on('$translateChangeSuccess', function () {
            vm.chart.api.refresh();
        });
        $scope.$on('$destroy', cleanListener);

        function generateData() {
            return [{
                    values: historyData.map(function (item) {
                        return {
                            x: new Date(item.dateTime),
                            y: item[vm.selectedChart].toFixed(2)
                        };
                    }),
                    key: charts[vm.selectedChart].name,
                    color: charts[vm.selectedChart].color
                }];
        }

        function generateOptions() {
            return {
                chart: {
                    type: 'lineChart',
                    margin: {
                        top: 5,
                        right: 20,
                        bottom: 20,
                        left: 30
                    },
                    height: 100,
                    showLegend: false,
                    noData: $filter('translate')('olt.detail.noData'),
                    yDomain: [0, 100],
                    xScale: d3.time.scale(),
                    xAxis: {
                        tickFormat: d3.time.format('%d/%m %H:%M'),
                        showMaxMin: false
                    },
                    yAxis: {
                        tickFormat: function (value) {
                            return value + '%';
                        },
                        ticks: 6
                    },
                    tooltip: {
                        enabled: false
                    },
                    pointSize: 0,
                    zoom: {
                        verticalOff: true
                    }
                }
            };
        }
    }
})();
